export const RESTAURANT_PRICE_CATEGORY_AVERAGE = 'average'

export default {
    average: RESTAURANT_PRICE_CATEGORY_AVERAGE,
}
